/// <reference path="../react-table-config.d.ts" />
import { CSSProperties } from '@material-ui/core/styles/withStyles'
import clsx from 'clsx'
import React from 'react'
import { Row } from 'react-table'
import { tableBodyStyles } from './tableBody.styles'

export interface TableBodyProps<TData extends Object> {
    cellCssOverride?: CSSProperties
    checkboxColumnWidth: number
    row: Row<TData>
    dataTestId?: string
}

const TableRow = <TData extends Object>({
    cellCssOverride,
    checkboxColumnWidth,
    row,
    dataTestId
}: TableBodyProps<TData>) => {
    const classes = tableBodyStyles(cellCssOverride)
    let leftStickyColumnIndex = 0,
        rightStickyColumnIndex = 0

    const { key: rowKey, ...rowProps } = row.getRowProps()
    
    return (
        <div
            key={rowKey}
            {...rowProps}
            className={clsx(
                classes.rowContainer,
                row.isGrouped && 'grouped-row',
                row.isExpanded && 'expanded',
                'tr'
            )}
            data-testId = {dataTestId || "tableRow"}
        >
            {row.cells.map((cell, index) => {
                if (cell.column?.sticky === 'left') {
                    leftStickyColumnIndex = index
                } else if (
                    cell.column?.sticky === 'right' &&
                    !rightStickyColumnIndex
                ) {
                    rightStickyColumnIndex = index
                }

                return (
                    <div
                        {...cell.getCellProps({
                            style: {
                                wordBreak: 'unset',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                verticalAlign: 'middle',
                                minHeight: 24,
                                minWidth:
                                    cell.column?.sticky === 'left'
                                        ? cell.column?.stickyLeftMargin ??
                                          checkboxColumnWidth
                                        : (cell.column as any)?.style
                                        ? (cell.column as any)?.style?.minWidth
                                        : 'unset',
                                left:
                                    cell.column?.sticky === 'left'
                                        ? cell.column?.stickyLeftMargin ??
                                          checkboxColumnWidth
                                        : 'unset',
                                right:
                                    cell.column?.sticky === 'right'
                                        ? cell.column?.stickyRightMargin ?? 0
                                        : 'unset',
                                position: !cell.column?.sticky
                                    ? 'unset'
                                    : 'sticky',
                                zIndex: !cell.column?.sticky ? 0 : 1,
                                backgroundColor: (cell?.column as any)?.style
                                    ? (cell?.column as any)?.style
                                          ?.backgroundColor
                                    : 'white',
                                ...cellCssOverride,
                            },
                        })}
                        className={clsx({
                            'grouped-cell': cell?.isGrouped || cell?.isAggregated,
                            'sticky-right':
                                rightStickyColumnIndex === index &&
                                cell?.column?.sticky === 'right',
                            'sticky-left':
                                leftStickyColumnIndex === index &&
                                cell?.column?.sticky === 'left',
                            td: true,
                        })}
                    >
                        {cell.isAggregated
                            ? cell?.render('Aggregated')
                            : cell.isPlaceholder
                            ? null
                            : cell?.render('Cell')}
                    </div>
                )
            })}
        </div>
    )
}

export default TableRow
